export default {
  yourlogo: {
    en: "Your logo here",
    fr: "Votre logo ici"
  }
};
